<template>
  <div class="jiejuefangan home baozhang about">
    <div id="nav" class="header">
      <head-top></head-top>
      <div class="default-title">
        <div class="default-title-top">让家居服务更简单</div>
        <div class="default-title-bottom">MAKE HOUSEHOLD EASIER</div>
      </div>
    </div>
    <div class="about-main">
      <div class="about-left">
        <aboutTab></aboutTab>
      </div>
      <div class="about-right">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import headTop from "./../../components/headTop";
import aboutTab from "./../../components/user/about_tab";
export default {
  components: {
    headTop,
    aboutTab
  },
  data() {
    return {};
  },
  mounted() {
    var _this = this;
  },
  methods: {}
};
</script>
<style lang="scss">
.about.home {
  margin-bottom: 0;
}
.about {
  #nav {
    background: url("../../assets/img/g_banner.jpg") no-repeat;
    background-size: cover;
    background-position: center;
    height: 400px;
    .head-rightBottom {
      .about {
        border-bottom: 2px solid #fff;
      }
    }
  }
}
.about-main {
  background: #f5f7fc;
  display: flex;
  padding-top: 40px;
  justify-content: center;
  overflow: hidden;
  .about-left {
    width: 291px;

    margin-right: 12px;
    margin-bottom: 100px;

    .about-title {
      color: #2f3133;
      font-size: 20px;
      height: 80px;
      border-bottom: 1px solid #e8ecf5;
      text-align: center;
      padding: 30px 105px;
      line-height: 1;
      margin-bottom: 10px;
    }
    .about-item {
      padding: 23px 0;
      line-height: 1;
      height: 60px;
      color: #2f3133;
      font-size: 14px;
      text-align: center;
      cursor: pointer;
    }
    .selected {
      background: #f7f8ff;
      border-left: 4px solid #3455d3;
      color: #3455d3;
      padding-right: 4px;
    }
    .about-item:hover {
      color: #3455d3;
    }
  }
  .about-right {
    width: 897px;
    margin-bottom: 100px;
  }
}
</style>